<div class="checkout-product-container">
    <div *ngFor="let productLine of products; trackBy: trackByFn" class="checkout-card-container">
        <div class="primary-info">
            <a [routerLink]="productLine.mhpId ? [MHP_BUILD_ROUTE] : [PRODUCT_ROUTE, ProductUtil.convertUsanaIdToDash(productLine.product.usanaId)]"
               [queryParams]="productLine.mhpId ? {type: 'edit', packId: productLine.mhpId} : {}">
                <product-image imageType="productImage"
                               imageSize="XS" [images]="productLine.product.productImages"
                               [imageAltText]="productLine?.product?.productDescription?.name"></product-image>
            </a>
            <div class="product-details-container">
                <div class="flex-col">
                    <a class="heading-5"
                       [routerLink]="productLine.mhpId ? [MHP_BUILD_ROUTE] : [PRODUCT_ROUTE, ProductUtil.convertUsanaIdToDash(productLine.product.usanaId)]"
                       [queryParams]="productLine.mhpId ? {type: 'edit', packId: productLine.mhpId} : {}"
                       [innerHTML]="productLine.product.productDescription.name"></a>
                    <p class="product-price">
                        {{ productLine.product.price.price | usanacurrency | async }}
                    </p>
                    <p *ngIf="shouldDisplayVolume" class="product-volume">
                        {{ 'cart.product.recommended.volume' | translate }} {{ productLine.product.price.volume }}
                    </p>
                    <fs-not-eligible [product]="productLine.product"></fs-not-eligible>
                </div>
                <div class="checkout-card-quantity">
                    <div class="quantity-container">
                        <button type="button" [attr.aria-label]="'cart.overview.quantity.remove.one.label' | translate"
                                class="cart-minus-button"
                                [disabled]="productLine.quantity < 2 || productLine.product.id == busyProductId || !productLine.product.editable"
                                (click)="decrement(productLine)"><i class="fa-solid fa-minus" aria-hidden="true"></i>
                        </button>
                        <input class="cart-quantity-input"
                               [(ngModel)]="productLine.quantity"
                               (keyup)="onKeyup(productLine)"
                               (focus)="onFocus(productLine)"
                               (onDebounce)="onChange(productLine)"
                               [debounceTime]="500"
                               type="text"
                               [attr.aria-label]="'cart.overview.quantity.label' | translate"
                               value="{{productLine.quantity}}"
                               [disabled]="!productLine.product.editable || !productLine.product.removable"
                               (blur)="onBlur(productLine)"/>
                        <button type="button" [attr.aria-label]="'cart.overview.quantity.add.one.label' | translate"
                                class="cart-plus-button"
                                [disabled]="productLine.product.id == busyProductId || !productLine.product.editable"
                                (click)="increment(productLine)"><i
                            class="fa-solid fa-plus" aria-hidden="true"></i></button>
                    </div>
                </div>
            </div>
            <div class="summary-action-wrapper">
                <span class="ao-upsell-status order-1" *ngIf="isAoUpsell && aoUpsellContains(productLine)">
                        <i class="fa-solid fa-rotate margin-right-4" aria-hidden="true"></i>
                        <span translate="cart.overview.product.ao.included"></span>
                </span>
                <span class="ao-upsell-status order-1" *ngIf="isAoUpsell && !canAddToAoUpsell(productLine) && !aoUpsellContains(productLine)"
                      translate="cart.overview.product.ao.unavailable"></span>
                <span class="summary-action-container">
                    <a href="javascript:void(0)" *ngIf="isAoUpsell && aoUpsellContains(productLine)"
                       (click)="removeAoUpsell(productLine)"
                       class="cart-product-summary-action ao-upsell-action order-2" translate="cart.overview.product.unsubscribe"></a>
                    <a *ngIf="isAoUpsell && canAddToAoUpsell(productLine) && !aoUpsellContains(productLine)"
                       href="javascript:void(0)" (click)="addAoUpsell(productLine)"
                       class="cart-product-summary-action ao-upsell-action order-2" translate="cart.overview.product.subscribe"></a>
                     <a *ngIf="allowCartSaveForLater && productLine.product.editable && productLine.product.removable" href="javascript:void(0)"
                        (click)="productSaveForLater(productLine)"
                        class="cart-product-summary-action order-3" translate='cart.product.save.for.later'></a>
                </span>
            </div>
        </div>
        <i [attr.aria-label]="'cart.button.close'| translate" class="fa-solid fa-xmark"
           (click)="onRemove(productLine)"></i>
    </div>
</div>
